export default __webpack_public_path__ + "img/ddJFVQvl.12d9fdd6.svg";